import { cn } from "@/core/helpers/cn";
import { CrossIcon } from "@/shared/icons";
import Button from "@/shared/ui/button/Button";

type Props = {
  onClose: () => void;
  className?: string;
};

export default function CloseButton({ onClose, className }: Props) {
  return (
    <Button
      className={cn("shrink-0 size-8 p-0", className)}
      color="gray"
      variant="soft"
      onClick={onClose}
    >
      <CrossIcon className="size-3" />
    </Button>
  );
}
